import { defineMessage } from 'magpie-lib/models';
import * as t from 'ts-schema';
export const newThreadConversationCreatedPublishMessage = defineMessage({
  type: '@assistant/new-thread-conversation-created',
  payloadSchema: t.object({
    conversationId: t.number,
    previousConversationCorrelationIds: t.array(t.string)
  })
});